import styled, { css } from "styled-components";
import { fontNormal } from "@tvg/atomic-ui/_static/Typography";
import buildColor from "@tvg/atomic-ui/_static/ColorPalette";

export const ConfirmContainer = styled.div`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  background-color: ${buildColor("white", "100")};
  padding: 20px;
`;

export const Paragraph = styled.p<{
  isSecondParagraph: boolean;
  isOnlyOneParagraph?: boolean;
}>`
  font-family: ${fontNormal};
  font-size: 14px;
  font-weight: 400;
  color: ${buildColor("grey", "800")};
  ${({ isSecondParagraph, isOnlyOneParagraph }) =>
    isSecondParagraph
      ? css`
          margin-bottom: 24px;
          font-weight: 700;
        `
      : css`
          margin-bottom: ${isOnlyOneParagraph ? "24px" : "2px"};
        `}
`;

export const ParagraphQuestion = styled.p`
  font-family: ${fontNormal};
  font-size: 14px;
  font-weight: 400;
  color: ${buildColor("grey", "800")};
  margin-bottom: 24px;
`;

export const CancelButtonWrapper = styled.div`
  margin-top: 12px;
`;
